module.exports = __webpack_public_path__ + "static/media/loading.cac6f4f6.gif";